// ABOUTME: Coalesces realtime publications into one flush per short window, so a burst of
// ABOUTME: events costs one invalidation pass and one refetch per record instead of one each.

/**
 * A morning of watch webhooks on a coach with a hundred athletes arrives as a
 * hundred publications within a second or two; the invalidation must see them
 * as one batch, or every chunk fetcher refetches a hundred times.
 */
export const EVENT_BUFFER_MS = 300

export interface EventBuffer<T> {
  push: (event: T) => void
  /** Drops what is pending; nothing flushes afterwards. */
  dispose: () => void
}

export function createEventBuffer<T>(flush: (events: T[]) => void, windowMs: number = EVENT_BUFFER_MS): EventBuffer<T> {
  let pending: T[] = []
  let timer: ReturnType<typeof setTimeout> | null = null

  return {
    push: (event) => {
      pending.push(event)
      if (timer !== null) return
      timer = setTimeout(() => {
        timer = null
        const events = pending
        pending = []
        flush(events)
      }, windowMs)
    },
    dispose: () => {
      if (timer !== null) clearTimeout(timer)
      timer = null
      pending = []
    },
  }
}
